
import smartWaterManageList from './src/smartWaterManageList.vue' //智慧水务列表

let views = {
  smartWaterManageList
};

export default views;